var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTulip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81845 15.7604L2.125 10.3018V4.88306L7.81845 10.3417V15.7604ZM8.51662 9.09056L4.51874 5.25759L8.51662 1.41666L12.5228 5.25759L8.51662 9.09056ZM9.22311 15.7604L14.875 10.3417V4.91494L9.22311 10.3417V15.7604Z",
    fill: "#0F1C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulip);
export default __webpack_public_path__ + "static/media/tulip.4c965d0277aeba0aad6b9635d2b582db.svg";
export { ForwardRef as ReactComponent };